import { Inject, Injectable } from '@angular/core';
import { Model, ModelFactory } from 'ngx-model';
import { Observable } from 'rxjs';
import { PosWarning } from '../classes/posWarning';
import { ApiEndpointsService } from './api-endpoints.service';
import { IHttpService } from './ihttp.service';
import { SortDirection } from 'src/app/directives/sortable/sortable.directive';
import { formatDate, KeyValue } from '@angular/common';

interface State {
  sortColumn: string;
  sortDirection: SortDirection;
}

const colorOrderMap = new Map([
  ['Rojo', 1],
  ['Naranja', 2],
  ['Verde', 3]
]);

@Injectable()
export class PosWarningService {
  private model: Model<PosWarning[]>;
  posWarning$: Observable<PosWarning[]>;

  private modelFiltered: Model<PosWarning[]>;
  posWarningFiltered$: Observable<PosWarning[]>;

  private _state: State = {
    sortColumn: '',
    sortDirection: '',
  };


  private colorOrderMap = new Map();

  constructor(
    private modelFactory: ModelFactory<PosWarning[]>,
    private apiEndpointsService: ApiEndpointsService,
    @Inject('HttpService') private httpService: IHttpService
  ) {
    //Todos los datos
    this.model = this.modelFactory.create([]);
    this.posWarning$ = this.model.data$;

    //Datos filtrados visibles en pantalla
    this.modelFiltered = this.modelFactory.create([]);
    this.posWarningFiltered$ = this.modelFiltered.data$;
  }

  getPosWarnings(): PosWarning[] {
    return this.model.get();
  }

  setPosWarning(data: PosWarning[]) {
    this.model.set(data);
  }

  getPosWarningsFiltered(): PosWarning[] {
    return this.modelFiltered.get();
  }

  setPosWarningsFiltered(data: PosWarning[]) {
    this.modelFiltered.set(data);
  }

  iniPosWarnings() {
    this.httpService
      .get(this.apiEndpointsService.getPosAlertsEndpoint())
      .subscribe((data) => {
        //console.log('data on iniPosWarnings:');
        //console.log(data);
        let posWarnings: PosWarning[] = [];
        if (data != null && data.value != null) {
          for (let i = 0; i < data.value.length; i++) {
            let entry = data.value[i];
            posWarnings.push(
              new PosWarning(
                entry.STOREKEY,
                entry.ACCOUNTNUMBER,
                entry.POS,
                entry.COMERCIALNAME,
                entry.TYPE,
                entry.COLOR,
                formatDate(new Date(), 'YYYY-MM-dd', 'en-US'),
                entry.ORIGIN,
                entry.GEO_INFO_CODE
              )
            );
          }
        }
        // posWarnings = _.orderBy(posWarnings, [this.colorOrderMap['indicator']],['asc']);
        posWarnings = posWarnings.sort((a, b) => (this.colorOrderMap.get(a.indicator) > this.colorOrderMap.get(b.indicator) ? 1 : -1));
        this.model.set(posWarnings);
        this.modelFiltered.set(posWarnings);
      });
  }

  filterPosWarnings(searchText: string) {
    searchText = searchText?.toLowerCase();
    //console.log(searchText);

    this.setPosWarningsFiltered(
      this.getPosWarnings().filter(
        (p) =>
          p.comercialName?.toLowerCase().includes(searchText) ||
          p.description?.toLowerCase().includes(searchText) ||
          p.date?.toLowerCase().includes(searchText)
      )
    );
  }

  set sortColumn(sortColumn: string) {
    this._set({ sortColumn });
  }

  set sortDirection(sortDirection: SortDirection) {
    this._set({ sortDirection });
  }

  private _set(patch: Partial<State>) {
    //console.log('sort post warnings');
    Object.assign(this._state, patch);
    this.sort();
  }

  private sort() {
    const { sortColumn, sortDirection } = this._state;
    // 1. sort
    this.setPosWarningsFiltered(
      sort(this.getPosWarnings(), sortColumn, sortDirection)
    );
  }
}

const compare = (v1: string | number, v2: string | number) =>
  v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

function sort(
  posWarnings: PosWarning[],
  column: string,
  direction: string
): PosWarning[] {
  ////console.log('----- Ordering poswarnings by: ');
  ////console.log(direction);
  ////console.log(column);
  ////console.log(' ---------------------  ');
  if (direction === '' || column === '') {
    return posWarnings;
  } else {
    return [...posWarnings].sort((a, b) => {
      const res = compare((a as any)[column]!, (b as any)[column]!);
      return direction === 'asc' ? res : -res;
    });
  }
}
